<template>
  <div v-if="visible" class="tip" @click.prevent="hide">
    <div class="text">{{ text }}</div>
    <div class="controls">
      <!-- Interface copy -->
      <button class="dismiss">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tip",
  props: ["text"],
  data: () => {
    return {
      visible: true,
    }
  },
  methods: {
    hide () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tip {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    bottom: -100px;
    right: 110px;
    max-width: calc(100% - 170px);
    padding: 0.75em 1em;
    background: $color-grey-light;
    background: fade-out($color: $color-grey-light, $amount: 0.2);
    border-radius: 5px;
    font-size: 0.7em;
    animation: tip-reveal 1s 0.75s forwards ease-in-out;
    z-index: 301;
    cursor: pointer;

    .text {
      margin-right: 1em;
      text-align: left;
    }

    .dismiss {
      padding: 0.3em 1em;
      line-height: 1;
      border: solid 2px $color-grey;
      background: $color-grey-black;
      border-radius: 60px;
      color: $color-white;
      cursor: pointer;
    }

    @media screen and (max-width: $break-mobile) {
      flex-flow: column nowrap;

      .text {
        margin-right: 0;
        margin-bottom: 1em;
        text-align: center;
      }
    }
  }

  @keyframes tip-reveal {
    0% {
      bottom: -100px;
    }
    100% {
      bottom: 30px;
    }
  }
</style>
